import { DateRangePicker, type DateRange } from "@visioni/a3s-ui/components";

/** A range of calendar days as the URL carries them, `YYYY-MM-DD`. */
export interface DayRangeValues {
  readonly from?: string | undefined;
  readonly to?: string | undefined;
}

interface ActivationDateRangeFieldProps {
  readonly value: DayRangeValues;
  readonly onChange: (next: { from: string | undefined; to: string | undefined }) => void;
  readonly placeholder: string;
}

const pad = (n: number) => String(n).padStart(2, "0");
const toDay = (date: Date | null): string | undefined =>
  date === null ? undefined : `${String(date.getFullYear())}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
const fromDay = (day: string | undefined): Date | null => {
  if (day === undefined) return null;
  const [y, m, d] = day.split("-").map(Number);
  return y === undefined || m === undefined || d === undefined ? null : new Date(y, m - 1, d);
};

export function ActivationDateRangeField({ value, onChange, placeholder }: ActivationDateRangeFieldProps) {
  const range: DateRange = { start: fromDay(value.from), end: fromDay(value.to) };

  return (
    <DateRangePicker
      value={range}
      onChange={(next) => onChange({ from: toDay(next.start), to: toDay(next.end) })}
      label="Date range"
      placeholder={placeholder}
      clearable
    />
  );
}
